var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImpulseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.566,
    height: 42,
    viewBox: "0 0 19.566 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "impulse_icon-01",
    "data-name": "impulse icon-01",
    transform: "translate(-15.4 -13.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33316",
    "data-name": "Path 33316",
    d: "M33.155,13.7H17.206A1.809,1.809,0,0,0,15.4,15.506V52.823a1.809,1.809,0,0,0,1.806,1.806h5.148l.061-.1a.43.43,0,0,0,.362.194H23.5a1.928,1.928,0,0,0,3.357,0h.724a.429.429,0,0,0,.357-.189l.041.071.015.026H33.16a1.809,1.809,0,0,0,1.806-1.806V15.506A1.817,1.817,0,0,0,33.155,13.7ZM21.5,50.736a.316.316,0,1,1-.316-.316A.318.318,0,0,1,21.5,50.736Zm-.923,0a.316.316,0,1,1-.316-.316A.318.318,0,0,1,20.573,50.736Zm-.923,0a.316.316,0,1,1-.316-.316A.315.315,0,0,1,19.65,50.736Zm-.918,0a.316.316,0,1,1-.316-.316A.318.318,0,0,1,18.732,50.736Zm-2.26-34.572a1.376,1.376,0,0,1,1.372-1.372H24.41v.464a.719.719,0,1,0,1.439,0v-.464h6.52a1.376,1.376,0,0,1,1.372,1.372V47.522a1.376,1.376,0,0,1-1.372,1.372H17.844a1.376,1.376,0,0,1-1.372-1.372Zm8.316-.913a.337.337,0,1,1,.337.337A.336.336,0,0,1,24.788,15.251Zm7.423,35.485a.316.316,0,1,1-.316-.316A.318.318,0,0,1,32.211,50.736Zm-.923,0a.316.316,0,1,1-.316-.316A.318.318,0,0,1,31.288,50.736Zm-.923,0a.316.316,0,1,1-.316-.316A.315.315,0,0,1,30.364,50.736Zm-.918,0a.316.316,0,1,1-.316-.316A.318.318,0,0,1,29.446,50.736Zm-4.27,4.48a1.458,1.458,0,0,1-1.092-.495h2.184A1.45,1.45,0,0,1,25.176,55.215Zm2.4-.75H22.772a.175.175,0,0,1-.153-.265l2.4-4.2L25.028,50a.236.236,0,0,1,.153-.056.246.246,0,0,1,.153.056l.005.005,2.4,4.2A.183.183,0,0,1,27.579,54.465Zm7.281-1.648a1.707,1.707,0,0,1-1.7,1.7h-5.1l-.061-.107.015-.061h5.158a1.568,1.568,0,0,0,1.561-1.561v-37.3a1.568,1.568,0,0,0-1.561-1.561H17.2a1.568,1.568,0,0,0-1.561,1.561V52.8A1.568,1.568,0,0,0,17.2,54.358h5.153c.005.02.01.041.015.056l-.066.112H17.206a1.707,1.707,0,0,1-1.7-1.7V15.506a1.707,1.707,0,0,1,1.7-1.7H33.155a1.707,1.707,0,0,1,1.7,1.7Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33317",
    "data-name": "Path 33317",
    d: "M188.41,762.9a1.01,1.01,0,1,0,1.01,1.01A1.012,1.012,0,0,0,188.41,762.9Z",
    transform: "translate(-163.224 -710.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33318",
    "data-name": "Path 33318",
    d: "M185.658,760a1.158,1.158,0,1,0,1.158,1.158A1.161,1.161,0,0,0,185.658,760Zm0,2.271a1.107,1.107,0,1,1,1.107-1.107A1.109,1.109,0,0,1,185.658,762.27Z",
    transform: "translate(-160.472 -708.223)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpulseIcon);
export default __webpack_public_path__ + "static/media/impulse-icon.3bd8118c97ede32df8d66fd7a94f9fe6.svg";
export { ForwardRef as ReactComponent };